$('.video-cta__video .video-button').one('click', function () {
    $(this).parents('.video-overlay').delay(200).fadeOut("slow");

    $(this).parents('.video-cta__video').find('iframe')[0].src += "&autoplay=1";
});